import config from './configs'
import axios from 'axios'
import {stringify} from 'qs'

const Apis = config.configs.API
let requests = {}
axios.defaults.withCredentials = true

function generateRequests (obj, parentKey) {
  for (let key in obj) {
    if (typeof (obj[key]) === 'object' && !obj[key].hasOwnProperty('url')) {
      generateRequests(obj[key], key)
    } else {
      let newkey = parentKey ? key[0].toUpperCase() + key.slice(1) : key
      requests[parentKey ? `${parentKey}${newkey}` : key] = (data) => {
        let url = obj[key].url
        let method = obj[key].method || 'get'
        let dataTransfer = {}
        let options = {}
        if (method === 'get') {
          dataTransfer = {
            params: data
          }
        } else {
          dataTransfer = data
        }
        if (obj[key].headers) {
          options.headers = obj[key].headers
          dataTransfer = stringify(dataTransfer)
        }
        return new Promise((resolve, reject) => {
          axios[method](url, dataTransfer, options)
            .then(res => {
              resolve(res)
            })
            .catch(err => {
              reject(err)
            })
        })
      }
    }
  }
}
generateRequests(Apis)
// for (let key in Apis) {
//   requests[key] = (data) => {
//     let url = Apis[key].url
//     let method = Apis[key].method || 'get'
//     let dataTransfer = {}
//     let options = {}
//     if (method === 'get') {
//       dataTransfer = {
//         params: data
//       }
//     } else {
//       dataTransfer = data
//     }
//     if (Apis[key].headers) {
//       options.headers = Apis[key].headers
//       dataTransfer = stringify(dataTransfer)
//     }
//     return new Promise((resolve, reject) => {
//       axios[method](url, dataTransfer, options)
//         .then(res => {
//           resolve(res)
//         })
//         .catch(err => {
//           reject(err)
//         })
//     })
//   }
// }

module.exports = requests



// WEBPACK FOOTER //
// ./src/requests.js